module.exports = __webpack_public_path__ + "img/index_fix_news.4882d771.jpg";